import MidtermAndFinalExamHFv4 from './component';

import _routes from './routes';

export const routes = _routes;

export default MidtermAndFinalExamHFv4;



// WEBPACK FOOTER //
// ./containers/Group/MidtermAndFinalExamHFv4/index.js